module.exports = __webpack_public_path__ + "img/1f918.873e7ef.svg";